import React, { useEffect, useState } from "react";
import axios from "axios";

const PathwayLaunch = () => {
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/pathway/sso/issue`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(({ data }) => {
      if (!active) return;
      const base = (process.env.REACT_APP_PATHWAY_URL || "https://pathway.udyogconnect.com").replace(/\/$/, "");
      window.location.assign(`${base}/auth/callback?code=${encodeURIComponent(data.code)}`);
    }).catch((requestError) => {
      if (active) setError(requestError?.response?.data?.message || "Pathway could not be opened.");
    });
    return () => { active = false; };
  }, []);
  return <div style={{ maxWidth: 640, margin: "80px auto", textAlign: "center" }}>
    <h1 style={{ fontFamily: "Georgia, serif" }}>{error ? "Pathway access" : "Opening Pathway…"}</h1>
    <p>{error || "Creating a secure sign-in handoff from your Udyog Connect account."}</p>
  </div>;
};
export default PathwayLaunch;
